import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import config from '../config/config';

firebase.default.initializeApp(config.firebaseConfig);

export const auth = firebase.auth();
